export default {
  // Region: "*** Setting AWS Region ***",
  // UserPoolId: "*** Setting UserPoolId ***",
  // ClientId: "*** Setting ClientId ***",
  // IdentityPoolId: "*** Setting IdentityPoolId ***"
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_WH1qYjDJZ",
  ClientId: "57bcab32ltigbgl22ic8rfroa2",
  IdentityPoolId: "ap-northeast-1:65f2e69d-8b4c-441c-8ef4-105a7d8fcfde"
};



// WEBPACK FOOTER //
// ./src/config.js